import { AxiosResponse } from 'axios';
import { apiUri } from '@/constants/Constants';
import userValues from '@/utils/normalizeUser';
import { client } from '@/shared/api';
import type { UserResponse } from '@/utils/types/User';

export const getUser = async () => {
  return await client
    .get(apiUri.getMe, { withCredentials: true })
    .then((resp: AxiosResponse<UserResponse>) => {
      return userValues(resp);
    });
};

export default getUser;
